import React from 'react';
import { IconCheckmark } from '@zillow/constellation';
import * as S from './styles';

const ChecklistItem = (props = {}) => (
    <S.ChecklistItem>
        <S.Icon>
            <IconCheckmark fontColor="blue400" size="xs" />
        </S.Icon>
        {props.children}
    </S.ChecklistItem>
);

export default ChecklistItem;
